const install = function (Vue) {
    Vue.prototype.xi18n = function (group, key) {
        const keyName = `${group}.${key}`;
        const args = [...arguments]?.slice(2);
        const values = [keyName].concat(args);
        return (this.$t.apply(this, values)).replace(`${group}.`, '');
    };
};
export default { install };
